import { ComponentProps } from "react";
import { FileDownloadButton } from "./FileDownloadButton";
import { useUser } from "../custom-hooks/useUser";

interface AccidentsExportButtonProps extends ComponentProps<typeof FileDownloadButton> {
    forceShow?: boolean;
}

export const AccidentsExportButton = ({ forceShow, ...props }: AccidentsExportButtonProps) => {
    const { isAdmin, isEjecutivo, usuario, fullName } = useUser();

    if (!forceShow && !isAdmin && !isEjecutivo && usuario !== "efi") return null;

    return <FileDownloadButton {...{ ...props, payloadSearch: { ...props.payloadSearch, fullName } }} />;
};
